import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  stylebutton: {
    borderRadius: '2rem',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    height: '32px',
    padding: '6px 12px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
      textTransform: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: '#ec6535',
      color: '#fff',
      opacity: 0.5,
    },
  },
  outlineButton: {
    borderRadius: '2rem',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    borderColor: 'black',
    textTransform: 'none',
    minWidth: '180px',
    height: '40px',
    padding: '8px 20px',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      minWidth: '150px',
      height: '36px',
      padding: '6px 16px',
      fontSize: '13px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '120px',
      height: '34px',
      padding: '6px 12px',
      fontSize: '12px',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      marginBottom: '8px',
    },
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
      textTransform: 'none',
    },
  },
  upload: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '2rem',
    minWidth: '180px',
    height: '40px',
    padding: '8px 20px',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      minWidth: '150px',
      height: '36px',
      padding: '6px 16px',
      fontSize: '13px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '120px',
      height: '34px',
      padding: '6px 12px',
      fontSize: '12px',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      marginBottom: '8px',
    },
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
  },
  blueButton: {
    backgroundImage: 'linear-gradient(to right, #301232, #1A2D6C,#173072)',
    color: 'white',
    border: '1px solid black',
    textTransform: 'none',
    borderRadius: '2rem',
    minWidth: '180px',
    height: '40px',
    padding: '8px 20px',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      minWidth: '150px',
      height: '36px',
      padding: '6px 16px',
      fontSize: '13px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '120px',
      height: '34px',
      padding: '6px 12px',
      fontSize: '12px',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      marginBottom: '8px',
    },
    '&:hover': {
      backgroundColor: 'green',
      background: 'green',
      color: 'white',
      border: '1px solid green',
    },
    // Disabled (feature not shipped yet): keep the gradient and white label
    // readable — MUI would otherwise fade the text to rgba(0,0,0,0.26), which
    // is invisible on this dark gradient. Opacity carries the disabled cue.
    '&.Mui-disabled': {
      backgroundImage: 'linear-gradient(to right, #301232, #1A2D6C,#173072)',
      color: 'white',
      border: '1px solid black',
      opacity: 0.5,
    },
  },
  clearText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: '#173072',
      textDecoration: 'underline',
    },
  },
  dpFlx: { display: 'flex' },
  algnCntr: { alignItems: 'center' },
  pointer: { cursor: 'pointer' },
  onHvrUndrline: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  accordionSummary: {
    paddingLeft: 0,
    '&.Mui-expanded': {
      minHeight: '50px',
    },
    '& .MuiAccordionSummary-content': {
      paddingLeft: 0,
      margin: 0,
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '10px 0px',
    },
  },
  statusChip: {
    fontWeight: 500,
    color: 'white',
    width: '120px',
    minWidth: '120px',
    maxWidth: '120px',
    textAlign: 'center',
    height: '32px',
    borderRadius: '4px',
    border: 'none',
    '& .MuiChip-label': {
      padding: '0 16px',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  expandIcon: {
    cursor: 'pointer',
    fontSize: '1.2rem',
  },
  actionSelect: {
    minWidth: '150px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '20px',
      height: '32px',
      backgroundColor: '#fff',
      outline: 'none !important',
      boxShadow: 'none !important',
      '& fieldset': {
        borderColor: '#E0E0E0',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: '#E0E0E0',
        borderWidth: '1px',
      },
      '&.Mui-focused': {
        outline: 'none !important',
        boxShadow: 'none !important',
        '& fieldset': {
          borderColor: '#E0E0E0',
          borderWidth: '1px',
        },
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E0E0E0',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E0E0E0',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E0E0E0',
      borderWidth: '1px',
    },
    '& .MuiSelect-select': {
      padding: '6px 14px',
      paddingRight: '32px',
      fontSize: '14px',
      color: '#666',
      fontWeight: 500,
      outline: 'none',
      '&:focus': {
        backgroundColor: 'transparent',
        outline: 'none',
      },
      [theme.breakpoints.up(1680)]: {
        fontSize: '16px',
      },
    },
    '& .MuiSelect-selectMenu': {
      padding: '6px 14px',
    },
    '& .MuiSelect-icon': {
      right: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  // Font matches the PO dashboard table (0.875rem, no responsive bump).
  col1to5: {
    fontSize: '0.875rem',
  },
  // CMO name can be long (e.g. "Patheon Toronto by Thermo Fisher Scientific").
  // Cap its width and let it wrap so it doesn't stretch the table and push the
  // date columns onto a new line.
  cmoColumn: {
    fontSize: '0.875rem',
    maxWidth: '150px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  projectIdColumn: {
    fontSize: '0.875rem',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
  col6: {
    fontSize: '0.875rem',
    // Keep Start / Expected End dates on a single line.
    whiteSpace: 'nowrap',
  },
  col7: {
    fontSize: '0.875rem',
  },
  col8to10: {
    fontSize: '0.875rem',
    '& .MuiButton-root': {
      fontSize: 'inherit !important',
      padding: 0,
      minWidth: 0,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      textTransform: 'none',
    },
    '& .MuiTextField-root': {
      fontSize: 'inherit',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 'inherit',
    },
    '& .MuiSelect-root': {
      fontSize: 'inherit',
    },
  },
  tableCellBody: {
    padding: '10px',
    borderBottom: '1px solid #C6C6C6',
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  headerCell: {
    padding: '10px',
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  redCard: {
    width: '100%',
    height: '120px',
    maxHeight: '120px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    border: '1px solid black',
    cursor: 'pointer',
    padding: '8px',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: '#FFD7D7',
    },
  },
  redText: {
    color: '#FF0000',
  },
  refreshContainerSty: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      paddingTop: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '1rem',
    },
  },
  refreshSty: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  formControl: {
    minWidth: 120,
    fontSize: '0.875rem',
  },
  formPerPage: {
    minWidth: 60,
    fontSize: '0.875rem',
    '& .MuiOutlinedInput-root': {
      outline: 'none !important',
      '&.Mui-focused': {
        outline: 'none !important',
        '& fieldset': {
          borderWidth: '1px !important',
        },
      },
    },
  },
  outlined: {
    padding: theme.spacing(1),
  },
  searchSelect: {
    '& .MuiOutlinedInput-root': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
      outline: 'none !important',
      '& fieldset': {
        borderRight: '1px solid #000 !important',
        borderColor: '#000 !important',
        borderWidth: '1px !important',
        borderTop: '1px solid #000 !important',
        borderBottom: '1px solid #000 !important',
        borderLeft: '1px solid #000 !important',
      },
      '&:hover fieldset': {
        borderRight: '1px solid #000 !important',
        borderColor: '#000 !important',
        borderWidth: '1px !important',
      },
      '&.Mui-focused': {
        outline: 'none !important',
        '& fieldset': {
          borderRight: '1px solid #000 !important',
          borderColor: '#000 !important',
          borderWidth: '1px !important',
          borderTop: '1px solid #000 !important',
          borderBottom: '1px solid #000 !important',
          borderLeft: '1px solid #000 !important',
        },
      },
    },
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      outline: 'none !important',
      '& fieldset': {
        borderLeft: 'none',
        borderColor: '#000 !important',
        borderWidth: '1px !important',
        borderTop: '1px solid #000 !important',
        borderBottom: '1px solid #000 !important',
        borderRight: '1px solid #000 !important',
      },
      '&:hover fieldset': {
        borderLeft: 'none',
        borderColor: '#000 !important',
        borderWidth: '1px !important',
        borderTop: '1px solid #000 !important',
        borderBottom: '1px solid #000 !important',
        borderRight: '1px solid #000 !important',
      },
      '&.Mui-focused': {
        outline: 'none !important',
        '& fieldset': {
          borderLeft: 'none',
          borderColor: '#000 !important',
          borderWidth: '1px !important',
          borderTop: '1px solid #000 !important',
          borderBottom: '1px solid #000 !important',
          borderRight: '1px solid #000 !important',
        },
      },
    },
  },
  cmoStageDropdown: {
    minWidth: '160px',
    maxWidth: '220px',
    width: '100%',
  },
  cmoBatchDropdown: {
    minWidth: '110px',
    maxWidth: '150px',
    width: '100%',
  },
  campaignIdDropdown: {
    minWidth: '120px',
    maxWidth: '160px',
    width: '100%',
  },
  unitProcedureColumn: {
    fontSize: '14px',
    [theme.breakpoints.up(1680)]: {
      fontSize: '16px',
    },
  },
  unitProcedureDropdown: {
    minWidth: '80px',
    maxWidth: '100px',
    width: '100%',
  },
  tableContainer: {
    marginTop: 20,
    marginBottom: 10,
    boxShadow: 'none',
    border: '1px solid #C6C6C6',
    borderTop: '1px solid #C6C6C6',
    borderRight: '1px solid #C6C6C6',
    borderBottom: '1px solid #C6C6C6',
    borderLeft: '1px solid #C6C6C6',
    borderRadius: '6px',
    overflow: 'hidden',
    overflowX: 'auto',
    width: '100%',
    boxSizing: 'border-box',
  },
}));

